module.exports = __webpack_public_path__ + "static/media/new_notice.37adaba6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/new_notice.mp3
// module id = 1135
// module chunks = 0